import { render, staticRenderFns } from "./crm-dialog-title.vue?vue&type=template&id=72a8876f&scoped=true"
import script from "./crm-dialog-title.vue?vue&type=script&lang=js"
export * from "./crm-dialog-title.vue?vue&type=script&lang=js"
import style0 from "./crm-dialog-title.vue?vue&type=style&index=0&id=72a8876f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a8876f",
  null
  
)

export default component.exports